/**
 * Public GRUV claims/refund Google Form used by /contact and the legal
 * BOTÓN DE ARREPENTIMIENTO. Keep a single URL so the button does not spawn a
 * second form or configuration.
 *
 * Frontend publish (DEV) and Frontend publish (PROD) bake the same public
 * string into NEXT_PUBLIC_GRUV_CONTACT_FORM_URL. This constant is the fallback
 * when that variable is unset.
 */
export const DEFAULT_GRUV_CONTACT_FORM_URL =
  "https://forms.gle/d5UBKZjNsLM6YTJg9";

/** Statutory label required on the consumer surface (Argentine distance-sale rule). */
export const WITHDRAWAL_BUTTON_LABEL = "BOTÓN DE ARREPENTIMIENTO";

/**
 * Resolves the public contact/refund form URL from the build-time
 * NEXT_PUBLIC_GRUV_CONTACT_FORM_URL value, falling back to the same default
 * used by `/contact` when the variable is unset.
 */
export function gruvContactFormUrl(): string {
  const fromEnv = process.env.NEXT_PUBLIC_GRUV_CONTACT_FORM_URL?.trim();
  return fromEnv || DEFAULT_GRUV_CONTACT_FORM_URL;
}
